<template>
  <qx-card title="需求信息">
    <DriverInfoDialog ref="driverInfoDialog" @sub="getData"></DriverInfoDialog>
    <qx-detail-box :data="detailData.base">
      <section slot="demandDetail">
        <DetailItem
            :detailItemList="demandDetailItemList"
            :orderDetail="orderDetail"
            propName="demandDetail"
        />
        <span class="seeLabel"
              v-if="detailRes.releaseScope===2 && detailRes.orderSourceDrivers.length>0"
              @click="toDriverDetail"
        >
          查看
        </span>
      </section>

    </qx-detail-box>

  </qx-card>
</template>

<script>
import DetailItem from './components/detailItem';
import DriverInfoDialog from './driverInfoDialog/driverInfoDialog';
export default {
  components: {
    DriverInfoDialog,
    DetailItem,
  },
  data () {
    return {
      orderDetail: {},
      detailRes: {},
      demandDetailItemList: [
        { label: '派车方式', value: 'dispatchMethod' },
        { label: '需求车次', value: 'requiredTrainNumber' },
        { label: '司机运价', value: 'driverTariff' },
        { label: '联系人', value: 'contacts' },
        { label: '联系人电话', value: 'contactsPhone' },
        { label: '发布范围', value: 'releaseScope' },
        { label: '截止时间', value: 'releaseDeadlineTime' },
      ],
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              {
                prop: 'demandDetail',
                label: '需求信息',
                slot: true,
                span: 1,
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    // 详情数据（用来展示）
    setBaseData (detailRes) {
      this.orderDetail.base = {
        demandDetail: this.getDemandDetailData(detailRes),
      };
      // 将对应模块的 详情数据 赋给 data 即可展示在页面上展示
      this.detailData.base.tableData.data = this.orderDetail.base;

    },
    // 审核数据（用来和 详情数据 做对比，如果和 详情数据不一样，则提示）
    // setBaseVerData (detailRes) {
    //   this.orderDetail.baseVer = {
    //     demandDetail: this.getDemandDetailData(detailRes),
    //
    //   };
    //   // 将对应模块的 审核数据 赋给 approveData 即可自动做对比
    //   this.detailData.base.tableData.approveData = this.orderDetail.baseVer;
    // },
    // 需求信息
    getDemandDetailData (detailRes) {
      return {
        dispatchMethod: detailRes.dispatchMethodName,
        requiredTrainNumber: detailRes.requiredTrainNumber + '辆',
        driverTariff: detailRes.orderGoodsDriverTariffs[0].goodsPriceDouble + detailRes.orderGoodsDriverTariffs[0].goodsUnit,
        contacts: detailRes.contacts,
        contactsPhone: detailRes.contactsPhone,
        releaseScope: detailRes.releaseScopeName,
        releaseDeadlineTime: detailRes.releaseDeadlineTime,
      };
    },
    toDriverDetail () {
      this.$refs.driverInfoDialog.show(this.detailRes.id);
    },
    async getData (detailRes) {
      // 详情数据
      this.orderDetail = {};
      // 重写各个模块的 详情数据，方便和 审核数据 做对比
      this.setBaseData(detailRes);
      if (this.$route.query.type === 'approve' && detailRes) {
        // 重写各个模块的 审核数据
        this.setBaseVerData(detailRes);
      }
      this.detailRes = detailRes;
    },
  },
};
</script>

<style scoped>
.seeLabel{
  position: relative;
  top: -74px;
  left: 180px;
  color: #409eff;
  cursor: pointer;
}

</style>
